{
  "version": 1,
  "asset_id": "a8f13365-db03-40e5-a709-20806675d796",
  "project_id": "4dbb42ac-931e-41e9-ac57-3f509e458f26",
  "url": "/__l5e/assets-v1/a8f13365-db03-40e5-a709-20806675d796/essentials-placeholder.jpg",
  "r2_key": "a/v1/4dbb42ac-931e-41e9-ac57-3f509e458f26/a8f13365-db03-40e5-a709-20806675d796/essentials-placeholder.jpg",
  "original_filename": "essentials-placeholder.jpg",
  "size": 230255,
  "content_type": "image/jpeg",
  "created_at": "2026-09-06T14:52:06Z"
}
